import {
  Component,
  EventEmitter,
  Input,
  OnChanges,
  OnDestroy,
  OnInit,
  Output,
  SimpleChanges,
  ViewChild,
} from '@angular/core';
import { UntypedFormControl, UntypedFormGroup, FormGroupDirective, Validators } from '@angular/forms';
import { LoadingSpaceType } from 'src/app/core/types';
import { Subscription } from 'rxjs';
import { maxErrorKey } from '../../../../shared/validators/validators';
import { Project } from '../../../../core/objects/project';
import {
  changeAllFormValuesNullIfEmptyString,
  clearAllErrorsIfAllValuesAreNull,
  conditionalRequiredValidator,
} from '../utils/utils';

@Component({
    selector: 'gl-loading-space-wheel-arches',
    templateUrl: './loading-space-wheel-arches.component.html',
    styleUrls: ['./loading-space-wheel-arches.component.scss'],
    standalone: false
})
export class LoadingSpaceWheelArchesComponent implements OnInit, OnChanges, OnDestroy {
  @Output() public submitEvent = new EventEmitter<any>();
  @Input() public chosenLoadingSpace: LoadingSpaceType;
  @Input() public loadingSpace: LoadingSpaceType;
  @Input() public typeLoadingSpace: number;
  @Input() public isEdit = false;
  @ViewChild('f', { static: false }) public formEl: FormGroupDirective;
  @Input() public project: Project;
  public form: WheelForm;
  public loadingSpaces: LoadingSpaceType[];
  public isTrailerOpen = true;
  public isSemitrailerOpen = false;
  public isSet = false;
  public loadingSpaceMod: LoadingSpaceType;
  private formSubscription: Subscription;
  private pattern = '^[+-]?([0-9]+([.][0-9]*)?|[.][0-9]+)$';
  private subscription: Subscription;

  constructor() {
    this.form = this.generateLoadingSpaceForm();
  }

  public ngOnInit() {
    this.updateSpaceModChange();
    this.subscription = this.form.valueChanges.subscribe((changes) => {
      if (
        (changes.width && changes.height && changes.distance) ||
        (changes.width2 && changes.height2 && changes.distance2)
      ) {
        this.addMaxValidators();
        this.updateSpaceMod();
      }
      this.onSubmit();
    });
    this.isSet = this.loadingSpace && this.loadingSpace.set;
    this.onChosen(this.loadingSpace);
    if (this.isEdit) {
      this.form.enable();
    } else {
      this.form.disable();
    }
    this.formSubscription = this.form.valueChanges.subscribe((changes) => {
      Object.keys(changes).forEach((key) => {
        if (changes[key] === '') {
          this.form.get(key).setValue(null, { emitEvent: false });
        }
      });
      this.addMaxValidators();
    });
  }

  public reload(): void {
    this.onChosen(this.chosenLoadingSpace);
  }

  private updateSpaceModChange(): void {
    this.loadingSpaceMod = {
      name: this.loadingSpace.name,
      length: this.loadingSpace.length,
      width: this.loadingSpace.width,
      height: this.loadingSpace.height,
      limit: this.loadingSpace.limit,
      length1: this.loadingSpace.length1,
      width1: this.loadingSpace.width1,
      height1: this.loadingSpace.height1,
      limit1: this.loadingSpace.limit1,
      set: true,
      type: this.loadingSpace.type,
      id: null,
      unit: this.loadingSpace.unit,
      axis: [],
      useInRecommendation: null,
      wheelTrailerWidth: this.loadingSpace.wheelTrailerWidth
        ? this.loadingSpace.wheelTrailerWidth
        : null,
      wheelTrailerHeight: this.loadingSpace.wheelTrailerHeight
        ? this.loadingSpace.wheelTrailerHeight
        : null,
      wheelTrailerLength: this.loadingSpace.wheelTrailerLength
        ? this.loadingSpace.wheelTrailerLength
        : null,
      wheelTrailerDistance: this.loadingSpace.wheelTrailerDistance
        ? this.loadingSpace.wheelTrailerDistance
        : null,
      wheelSemiTrailerWidth: this.loadingSpace.wheelSemiTrailerWidth
        ? this.loadingSpace.wheelSemiTrailerWidth
        : null,
      wheelSemiTrailerHeight: this.loadingSpace.wheelSemiTrailerHeight
        ? this.loadingSpace.wheelSemiTrailerHeight
        : null,
      wheelSemiTrailerLength: this.loadingSpace.wheelSemiTrailerLength
        ? this.loadingSpace.wheelSemiTrailerLength
        : null,
      wheelSemiTrailerDistance: this.loadingSpace.wheelSemiTrailerDistance
        ? this.loadingSpace.wheelSemiTrailerDistance
        : null,
      coolerTrailerWidth: null,
      coolerTrailerHeight: null,
      coolerTrailerLength: null,
      coolerTrailerFloorHeight: null,
      coolerSemiTrailerWidth: null,
      coolerSemiTrailerHeight: null,
      coolerSemiTrailerLength: null,
      coolerSemiTrailerFloorHeight: null,
      varioTrailerFloorHeight: null,
      varioSemiTrailerFloorHeight: null,
    };
  }

  private updateSpaceMod(): void {
    const width =
      this.form.get('width').value !== null ? parseFloat(this.form.get('width').value) : null;
    const height =
      this.form.get('height').value !== null ? parseFloat(this.form.get('height').value) : null;
    const length =
      this.form.get('length').value !== null ? parseFloat(this.form.get('length').value) : null;
    const distance =
      this.form.get('distance').value !== null ? parseFloat(this.form.get('distance').value) : null;
    const width2 =
      this.form.get('width2').value !== null ? parseFloat(this.form.get('width2').value) : null;
    const height2 =
      this.form.get('height2').value !== null ? parseFloat(this.form.get('height2').value) : null;
    const length2 =
      this.form.get('length2').value !== null ? parseFloat(this.form.get('length2').value) : null;
    const distance2 =
      this.form.get('distance2').value !== null
        ? parseFloat(this.form.get('distance2').value)
        : null;
    this.loadingSpaceMod = {
      name: this.loadingSpace.name,
      length: this.loadingSpace.length,
      width: this.loadingSpace.width,
      height: this.loadingSpace.height,
      limit: this.loadingSpace.limit,
      length1: this.loadingSpace.length1,
      width1: this.loadingSpace.width1,
      height1: this.loadingSpace.height1,
      limit1: this.loadingSpace.limit1,
      set: true,
      type: this.loadingSpace.type,
      id: null,
      unit: this.loadingSpace.unit,
      axis: [],
      useInRecommendation: null,
      wheelTrailerWidth: width,
      wheelTrailerHeight: height,
      wheelTrailerLength: length,
      wheelTrailerDistance: distance,
      wheelSemiTrailerWidth: width2,
      wheelSemiTrailerHeight: height2,
      wheelSemiTrailerLength: length2,
      wheelSemiTrailerDistance: distance2,
      coolerTrailerWidth: null,
      coolerTrailerHeight: null,
      coolerTrailerLength: null,
      coolerTrailerFloorHeight: null,
      coolerSemiTrailerWidth: null,
      coolerSemiTrailerHeight: null,
      coolerSemiTrailerLength: null,
      coolerSemiTrailerFloorHeight: null,
      varioTrailerFloorHeight: null,
      varioSemiTrailerFloorHeight: null,
    };
  }

  public ngOnChanges(changes: SimpleChanges) {
    if (
      changes.loadingSpace &&
      changes.loadingSpace.currentValue &&
      changes.loadingSpace.currentValue.width &&
      changes.loadingSpace.currentValue.height &&
      changes.loadingSpace.currentValue.length
    ) {
      this.updateSpaceModChange();
      this.addMaxValidators();
    }
    if (
      changes.chosenLoadingSpace &&
      changes.chosenLoadingSpace.currentValue !== changes.chosenLoadingSpace.previousValue
    ) {
      this.onChosen(changes.chosenLoadingSpace.currentValue as LoadingSpaceType);
    }
    if (changes.typeLoadingSpace && !changes.typeLoadingSpace.firstChange) {
      this.form.reset(undefined, { onlySelf: true, emitEvent: false });
    }
    this.isSet =
      changes.loadingSpace &&
      changes.loadingSpace.currentValue &&
      (changes.loadingSpace.currentValue.set as boolean);
    if (changes.isEdit && changes.isEdit.currentValue) {
      this.isEdit = true;
      this.form.enable();
    } else if (changes.isEdit && !changes.isEdit.currentValue) {
      this.isEdit = false;
      this.form.disable();
    }
  }

  public onSubmit(): void {
    changeAllFormValuesNullIfEmptyString(this.form);
    clearAllErrorsIfAllValuesAreNull(this.form);
    if (this.form.dirty) {
      this.formEl?.onSubmit(undefined);
    }
    const isLoadingSpace: boolean =
      this.loadingSpace &&
      typeof this.loadingSpace.width === 'number' &&
      typeof this.loadingSpace.height === 'number' &&
      typeof this.loadingSpace.length === 'number';
    const isSet: boolean = this.loadingSpace && this.loadingSpace.set;
    const isTrailerValid: boolean = this.isTrailerValid();
    const isSemiTrailerValid: boolean = this.isSemiTrailerValid();
    const trailerFormValue = {
      length: this.form.get('length').value,
      height: this.form.get('height').value,
      width: this.form.get('width').value,
      distance: this.form.get('distance').value,
    };
    if (isLoadingSpace && !isSet && isTrailerValid) {
      const canEmit: boolean = this.canEmit();
      if (canEmit) {
        this.submitEvent.emit(trailerFormValue);
      }
    }
    if (isLoadingSpace && isSet && isSemiTrailerValid) {
      let semiTrailersFormValue = {
        length2: this.form.get('length2').value,
        height2: this.form.get('height2').value,
        width2: this.form.get('width2').value,
        distance2: this.form.get('distance2').value,
      };
      if (isTrailerValid) {
        semiTrailersFormValue = {
          ...trailerFormValue,
          ...semiTrailersFormValue,
        };
      }
      const canEmit: boolean = this.canEmit(false);
      if (canEmit) {
        this.submitEvent.emit(semiTrailersFormValue);
      }
    }
  }

  private canEmit(trailer = true): boolean {
    if (trailer) {
      const isTrailerNotFull: boolean =
        this.form.get('length').value === null ||
        this.form.get('height').value === null ||
        this.form.get('width').value === null ||
        this.form.get('distance').value === null;
      const isTrailerAllNull: boolean =
        this.form.get('length').value === null &&
        this.form.get('height').value === null &&
        this.form.get('width').value === null &&
        this.form.get('distance').value === null;
      return !isTrailerNotFull || isTrailerAllNull;
    } else {
      const isSemiTrailerNotFull: boolean =
        this.form.get('length2').value === null ||
        this.form.get('height2').value === null ||
        this.form.get('width2').value === null ||
        this.form.get('distance2').value === null;
      const isSemiTrailerAllNull: boolean =
        this.form.get('length2').value === null &&
        this.form.get('height2').value === null &&
        this.form.get('width2').value === null &&
        this.form.get('distance2').value === null;
      return !isSemiTrailerNotFull || isSemiTrailerAllNull;
    }
  }

  public onChosen(loadingSpace: LoadingSpaceType): void {
    if (!loadingSpace) {
      return;
    }
    this.form.patchValue({
      length: loadingSpace.wheelTrailerLength ? loadingSpace.wheelTrailerLength : null,
      height: loadingSpace.wheelTrailerHeight ? loadingSpace.wheelTrailerHeight : null,
      width: loadingSpace.wheelTrailerWidth ? loadingSpace.wheelTrailerWidth : null,
      distance: loadingSpace.wheelTrailerDistance ? loadingSpace.wheelTrailerDistance : null,
      length2: loadingSpace.wheelSemiTrailerLength ? loadingSpace.wheelSemiTrailerLength : null,
      height2: loadingSpace.wheelSemiTrailerHeight ? loadingSpace.wheelSemiTrailerHeight : null,
      width2: loadingSpace.wheelSemiTrailerWidth ? loadingSpace.wheelSemiTrailerWidth : null,
      distance2: loadingSpace.wheelSemiTrailerDistance
        ? loadingSpace.wheelSemiTrailerDistance
        : null,
    });
  }

  public formReset(): void {
    this.resetTrailerForm();
    this.resetSemiTrailerForm();
    this.submitEvent.emit(this.form.value);
  }

  private resetTrailerForm(): void {
    this.form.patchValue({
      length: null,
      height: null,
      width: null,
      distance: null,
    });
  }

  private resetSemiTrailerForm(): void {
    this.form.patchValue({
      length2: null,
      height2: null,
      width2: null,
      distance2: null,
    });
  }

  public openTab(tabName: string): void {
    this.isTrailerOpen = false;
    this.isSemitrailerOpen = false;
    switch (tabName) {
      case 'trailer':
        this.isTrailerOpen = true;
        break;
      case 'semitrailer':
        this.isSemitrailerOpen = true;
        break;
    }
  }

  private setControlValidator(name: string, max: number): void {
    this.form.controls[name].clearValidators();
    this.form
      .get(name)
      .setValidators([
        Validators.min(0),
        Validators.pattern(this.pattern),
        maxErrorKey(max, 'wheelMax'),
        conditionalRequiredValidator(this.form, name.endsWith('2')),
      ]);
    this.form.controls[name].updateValueAndValidity({ onlySelf: true, emitEvent: true });
  }

  private addMaxValidators(): void {
    if (!this.loadingSpace) {
      return;
    }
    if (this.loadingSpace.width && this.loadingSpace.height && this.loadingSpace.length) {
      const maxWidth = this.loadingSpace.width;
      const wheelMaxWidth = maxWidth / 2;
      const maxHeight = this.loadingSpace.height;
      const maxLength = this.loadingSpace.length;
      const maxDistance = maxLength - this.form.get('length').value;
      const maxWheelLength = maxLength - this.form.get('distance').value;
      this.setControlValidator('height', maxHeight);
      this.setControlValidator('width', wheelMaxWidth);
      this.setControlValidator('length', maxWheelLength);
      this.setControlValidator('distance', maxDistance);
    }
    if (
      this.loadingSpace.set &&
      this.loadingSpace.width1 &&
      this.loadingSpace.height1 &&
      this.loadingSpace.length1
    ) {
      const maxWidth2 = this.loadingSpace.width1;
      const wheelMaxWidth2 = maxWidth2 / 2;
      const maxHeight2 = this.loadingSpace.height1;
      const maxLength2 = this.loadingSpace.length1;
      const maxDistance2 = maxLength2 - this.form.get('length').value;
      const maxWheelLength2 = maxLength2 - this.form.get('distance').value;
      this.setControlValidator('height2', maxHeight2);
      this.setControlValidator('width2', wheelMaxWidth2);
      this.setControlValidator('length2', maxWheelLength2);
      this.setControlValidator('distance2', maxDistance2);
    }
  }

  private generateLoadingSpaceForm(): WheelForm {
    return new UntypedFormGroup({
      length: new UntypedFormControl(null),
      width: new UntypedFormControl(null),
      height: new UntypedFormControl(null),
      distance: new UntypedFormControl(null),
      length2: new UntypedFormControl(null),
      width2: new UntypedFormControl(null),
      height2: new UntypedFormControl(null),
      distance2: new UntypedFormControl(null),
    });
  }

  private isTrailerValid(): boolean {
    return (
      this.form.get('length').valid &&
      this.form.get('height').valid &&
      this.form.get('width').valid &&
      this.form.get('distance').valid
    );
  }

  private isSemiTrailerValid(): boolean {
    return (
      this.form.get('length2').valid &&
      this.form.get('height2').valid &&
      this.form.get('width2').valid &&
      this.form.get('distance2').valid
    );
  }

  ngOnDestroy(): void {
    this.formSubscription.unsubscribe();
    this.subscription.unsubscribe();
  }
}

interface WheelForm extends UntypedFormGroup {
  value: {
    length: number;
    height: number;
    width: number;
    distance: number;
    length2: number;
    height2: number;
    width2: number;
    distance2: number;
  };
}
